export default __webpack_public_path__ + "static/media/gallery-wip-emitter_17.5973a130.jpg";